import {AnalyticsProvider as ConversationsUIAnalyticsProvider} from '@stripe-internal/conversations-ui';
import {InlineDataEventBusProvider} from '@stripe-internal/inline-data/dist/InlineDataEventBusProvider';
import {TwilioClientProvider} from './TwilioClientProvider';
import {UniversalHelpClientProvider} from './UniversalHelpClientProvider';
import {useClientAnalytics} from './useClientAnalytics';
import {useProfile} from '../ProfileProvider';

type Props = {
  children: JSX.Element;
};

const ConversationAnalyticsProvider = ({children}: Props) => {
  const analytics = useClientAnalytics();

  return (
    <ConversationsUIAnalyticsProvider analytics={analytics}>
      {children}
    </ConversationsUIAnalyticsProvider>
  );
};

export const ClientProvider = ({children}: Props) => {
  const {profile} = useProfile();

  if (profile.featureFlags.enableUniversalHelp) {
    return (
      <InlineDataEventBusProvider>
        <UniversalHelpClientProvider>
          <ConversationAnalyticsProvider>
            {children}
          </ConversationAnalyticsProvider>
        </UniversalHelpClientProvider>
      </InlineDataEventBusProvider>
    );
  }

  return (
    <TwilioClientProvider>
      <ConversationAnalyticsProvider>{children}</ConversationAnalyticsProvider>
    </TwilioClientProvider>
  );
};
